import { Typography, Grid, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText, InputLabel, Select, MenuItem, Divider, Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createNewDraft, getFanDetails, getFanData, getFetchingError, getProjectDetails, getProjectState, updateProjectDetails, getGADetails, updateGADetails } from "../../app/reducer/project.reducer";
import { bladeMaterialArr, bushMaterialArr, clampMaterialArr, driveTypeArr, GADrawingFormInputs, gaHeadingArr, gaMaterialsArr, hardwareMaterialArr, hubPlateMaterialArr } from "../../app/utils/formData";
import {useAppSelector} from "../../app/hooks"
import React, { useEffect } from "react";
import AlertComponent from "../general/Alert";import { getUser } from "../../app/reducer/auth.reducer";

// projectState(pin):"saved";

const useStyles = makeStyles((theme: Theme) =>
createStyles({
    radioGroup:{
    display: 'flex',
    flexDirection: 'row'
    },
    formControl: {
    width: '100%',
    },
    radioWrapped: {
    marginLeft: theme.spacing(2),
    },
    selectEmpty: {
    marginTop: theme.spacing(2),
    },
}),
);

export default function GADrawingForm({setIndex}:{setIndex:Function}):JSX.Element {
    const [busy, setBusy] = React.useState<boolean>(false);
    const [openAlert, setOpenAlert] = React.useState<boolean>(false);
    const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);
    

    const classes = useStyles();
    
    const projectState = useAppSelector(getProjectState);
    const fanDetails = useAppSelector(getFanDetails);
    const gaDetails = useAppSelector(getGADetails);
    const fanData = useAppSelector(getFanData);
    const projectDetails = useAppSelector(getProjectDetails)||{};
    const fetchingErr = useAppSelector(getFetchingError);
    const user = useAppSelector(getUser);
    console.log(fanDetails,projectDetails)
    // console.log("projectDetails,",projectDetails)
    // console.log("fanData,",fanData)
    const getKeyFromText = (arr: any[], value: any) => {
  if (!value) return "";
  
  const match = arr.find(
    (el: any) => el.key === value || el.text === value
  );
  
  return match ? match.key : "";
};
    const mapping = {
      hub_spool_mat: getKeyFromText(hardwareMaterialArr, fanDetails.hardware_material),
      hub_plate_mat: getKeyFromText(hubPlateMaterialArr, fanDetails.hub_plate_material),
      clamp_mat: getKeyFromText(clampMaterialArr, fanDetails.clamp_material),
      clamp_hardware_mat: getKeyFromText(hardwareMaterialArr, fanDetails.hardware_material),//
      hub_spool_hardware_mat: getKeyFromText(hardwareMaterialArr, fanDetails.hardware_material),//
      blades_mat: getKeyFromText(bladeMaterialArr, fanDetails.blade_material),
      fan_drive: getKeyFromText(driveTypeArr, fanDetails.drive_type),
    };
    const { register, formState, getValues, setValue, handleSubmit, control, formState: { errors } } = useForm<GADrawingFormInputs>({
  defaultValues: mapping
});
    const dispatch = useDispatch()


    const createDraft = async (data:GADrawingFormInputs) => {
      // if(busy) return;
      // await dispatch(createNewDraft(data));
      // if(fetchingErr===false){
      //   dispatch(updateProjectDetails(data));
      //   setOpenAlert(true);
      // }else{
      //   setOpenErrAlert(true);
      // }
    }
    
    useEffect(() => {
      console.log(fanDetails)
      setValue('make', 'ENCON');
      setValue('model_number', fanData.fanModelID);
      // setValue('part_number', `LB-${} / DH-${}`);
      setValue('fan_diameter', (fanDetails.fan_diameter?parseFloat(fanDetails.fan_diameter):fanData.fanDiameter));
      setValue('no_of_blades', fanData.numofBlades);
      setValue('fan_rpm', fanDetails.fan_speed?fanDetails.fan_speed:fanData.rpm);
      if(fanDetails.drive_type){
        setValue('fan_drive',fanDetails.drive_type);
      }
      if(fanDetails.motor_rating){
        setValue('motor_power',fanDetails.motor_rating);
      }
      if(fanDetails.motor_rpm){
        setValue('motor_rpm',fanDetails.motor_rpm);
      }
      if(fanDetails.set_no){
        setValue('qty',Number(fanDetails.set_no));
      }
      if(fanDetails.application){
        setValue('application',fanDetails.application);
      }

      
      // if(fanDetails.bush_material){
      //   setValue('hub_spool_spec',fanDetails.bush_material);
      // }
      // if(fanDetails.hub_plate_material){
      //   setValue('hub_plate_spec',fanDetails.hub_plate_material);
      // }
      // if(fanDetails.clamp_material){
      //   setValue('clamp_spec',fanDetails.clamp_material);
      // }
      // if(fanDetails.hardware_material){
      //   setValue('clamp_hardware_spec',fanDetails.hardware_material);
      //   setValue('hub_spool_hardware_spec',fanDetails.hardware_material);
      // }
      // if(fanDetails.blade_material){
      //   setValue('blades_spec',fanDetails.blade_material);
      // }

      if(projectDetails.customer_name){
        setValue('client',projectDetails.customer_name);
      }
      else
      {
        setValue('client','');
      }
      if(projectDetails.location){
        setValue('client_location',projectDetails.location);
      }
      if(projectDetails.po_number){
        setValue('po_number',projectDetails.po_number);
      }
      // if(fanDetails.hardware_material){
      //   setValue('po_date',fanDetails.hardware_material);
      // }
      if(projectDetails.company_name){
        setValue('company_name',projectDetails.company_name);
      }

      setValue('dimension_a',Math.round((fanDetails.fan_diameter?parseFloat(fanDetails.fan_diameter):fanData.fanDiameter)*1000));
      setValue('dimension_b',fanData.bladeModel.bladeLength);
      setValue('dimension_c',(fanDetails.hub_diameter?fanDetails.hub_diameter:fanData.hub.hubDiameter*1000));
      if(fanDetails.hub_bore_diameter){
        setValue('dimension_d',fanDetails.hub_bore_diameter);
      }
      if(fanDetails.keyway){
        setValue('dimension_e',fanDetails.keyway);
      }
      setValue('dimension_f',fanData.bladeModel.shoulderChord);
      setValue('dimension_g',fanData.bladeModel.tipChord);


      if(gaDetails){
        for (const [key, value] of Object.entries(gaDetails)) {
          // console.log(`${key}: ${value}`);
          let anykey = key as any;
          setValue(anykey,value);
        }}
            //         const mapping = {
            //   hub_spool_mat: getKeyFromText(hardwareMaterialArr, fanDetails.bush_material),
            //   hub_plate_mat: getKeyFromText(hubPlateMaterialArr, fanDetails.hub_plate_material),
            //   clamp_mat: getKeyFromText(clampMaterialArr, fanDetails.clamp_material),
            //   clamp_hardware_mat: getKeyFromText(hardwareMaterialArr, fanDetails.hardware_material),
            //   hub_spool_hardware_mat: getKeyFromText(hardwareMaterialArr, fanDetails.hardware_material),
            //   blades_mat: getKeyFromText(bladeMaterialArr, fanDetails.blade_material),
            // };

            // Object.entries(mapping).forEach(([key, val]) => {
            //   if (val) setValue(key as any, val);
            //   console.log(key,val);
            // });
    }, [])

    // useEffect(() => {

    //   if(projectState==='new'){
    //     const now = new Date().getTime();
    //     let uid = "";
    //     if(user.user) uid = user.user?.username.substring(0, 2).toUpperCase();
    //     setValue("draft_project_number", "DR-"+uid+now.toString());
    //     setValue("project_number", "PR-"+uid+now.toString());
    //   }else{
    //     let projName = projectDetails.draft_project_number.split("-")[1];
    //     setValue("project_number", "PR-"+projName);
    //   }
    //   // projectDetails.forEach(({key, value}:{key:any, value:any}) => {
    //   //   setValue(key,value);
    //   // });
     

    // }, [])
    
    const onSubmit: SubmitHandler<GADrawingFormInputs> = async data => {
      // setBusy(true);
      // setOpenAlert(false);
      // await dispatch(updateProjectDetails(data));
      // setOpenAlert(true);
      // setBusy(false);
      // // console.log("PROJ", data);
      dispatch(updateGADetails(data));
      setIndex(7)
    };

    const viewIn3D =()=>{
     const url = 'https://main.d21het1hwiprnz.amplifyapp.com/?fanModelID='+fanData.fanModelID;
      window.open(url, '_blank');
    }

    return (
        <form id="fan-details-form" onSubmit={handleSubmit(onSubmit)} style={{padding:'5px'}}>
        <Typography variant="h5" gutterBottom>
          <b>Information block A (GENERAL DATA)</b>
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Name"
              {...register("name")}
              variant="outlined" fullWidth
              error={(errors.name?true:false)}
              helperText={errors.name?'Please enter customer name':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Application"
              {...register("application")}
              variant="outlined" fullWidth
              error={(errors.application?true:false)}
              helperText={errors.application?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Location"
              {...register("location")}
              variant="outlined" fullWidth
              error={(errors.location?true:false)}
              helperText={errors.location?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Make"
              {...register("make")}
              variant="outlined" fullWidth
              error={(errors.make?true:false)}
              helperText={errors.make?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Model Number"
              {...register("model_number")}
              variant="outlined" fullWidth
              error={(errors.model_number?true:false)}
              helperText={errors.model_number?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Part Number"
              {...register("part_number")}
              variant="outlined" fullWidth
              error={(errors.part_number?true:false)}
              helperText={errors.part_number?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Fan Diameter"
              {...register("fan_diameter")}
              variant="outlined" fullWidth
              error={(errors.fan_diameter?true:false)}
              helperText={errors.fan_diameter?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="No. of Blades"
              {...register("no_of_blades")}
              variant="outlined" fullWidth
              error={(errors.no_of_blades?true:false)}
              helperText={errors.no_of_blades?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Fan RPM"
              {...register("fan_rpm")}
              variant="outlined" fullWidth
              error={(errors.fan_rpm?true:false)}
              helperText={errors.fan_rpm?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            {/* <TextField
              label="Fan Drive"
              {...register("fan_drive")}
              variant="outlined" fullWidth
              error={(errors.fan_drive?true:false)}
              helperText={errors.fan_drive?'This field is required':''}
            /> */}

              <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Fan Drive</InputLabel>
              <Controller
                control={control}
                name="fan_drive"
                render={({ field: { onChange, value } }) => (
                  <Select
                    value={value}
                    onChange={onChange}
                    label="fan-drive-label"
                  >
                    <MenuItem style={{fontSize:'20px'}} value="">
                                        <em>None</em>
                                      </MenuItem>
                                      {driveTypeArr.map(el => {
                                        return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                                      })
                                      }
                  </Select>
                )}
              />
              <FormHelperText>{errors.fan_drive ? 'This field is required' : ''}</FormHelperText>
              </FormControl>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Gear Box Model No. "
              {...register("gearbox_model_no")}
              variant="outlined" fullWidth
              error={(errors.gearbox_model_no?true:false)}
              helperText={errors.gearbox_model_no?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Reduction Ratio"
              {...register("reduction_ratio")}
              variant="outlined" fullWidth
              error={(errors.reduction_ratio?true:false)}
              helperText={errors.reduction_ratio?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Motor Power"
              {...register("motor_power")}
              variant="outlined" fullWidth
              error={(errors.motor_power?true:false)}
              helperText={errors.motor_power?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Motor RPM"
              {...register("motor_rpm")}
              variant="outlined" fullWidth
              error={(errors.motor_rpm?true:false)}
              helperText={errors.motor_rpm?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Qty"
              {...register("qty")}
              variant="outlined" fullWidth
              error={(errors.qty?true:false)}
              helperText={errors.qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Item Code No."
              {...register("item_code_no")}
              variant="outlined" fullWidth
              error={(errors.item_code_no?true:false)}
              helperText={errors.item_code_no?'This field is required':''}
            />
          </Grid>
        </Grid>

        <br/>
        <Divider />
        <br/>

        <Typography variant="h5" gutterBottom>
          <b>Information block B (PART LIST)</b>
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            Hub Spool:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.hub_spool_mat?true:false}>
              <InputLabel>Hub spool Material</InputLabel>
                <Controller
                  control={control}
                  name="hub_spool_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Hub spool Material"
                    >
                      {bushMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.hub_spool_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Spool Specifications"
              {...register("hub_spool_spec")}
              variant="outlined" fullWidth
              error={(errors.hub_spool_spec?true:false)}
              helperText={errors.hub_spool_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Spool Qty" type="number"
              {...register("hub_spool_qty")}
              variant="outlined" fullWidth
              error={(errors.hub_spool_qty?true:false)}
              helperText={errors.hub_spool_qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12}>
            Hub Plate:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.hub_plate_mat?true:false}>
              <InputLabel>Hub plate Material</InputLabel>
                <Controller
                  control={control}
                  name="hub_plate_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Hub plate Material"
                    >
                      {hubPlateMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.hub_plate_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Plate Specifications"
              {...register("hub_plate_spec")}
              variant="outlined" fullWidth
              error={(errors.hub_plate_spec?true:false)}
              helperText={errors.hub_plate_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Plate Qty" type="number"
              {...register("hub_plate_qty")}
              variant="outlined" fullWidth
              error={(errors.hub_plate_qty?true:false)}
              helperText={errors.hub_plate_qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12}>
            Clamp:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.clamp_mat?true:false}>
              <InputLabel>Clamp Material</InputLabel>
                <Controller
                  control={control}
                  name="clamp_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Clamp Material"
                    >
                      {clampMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.clamp_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Clamp Specifications"
              {...register("clamp_spec")}
              variant="outlined" fullWidth
              error={(errors.clamp_spec?true:false)}
              helperText={errors.clamp_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Clamp Qty" type="number"
              {...register("clamp_qty")}
              variant="outlined" fullWidth
              error={(errors.clamp_qty?true:false)}
              helperText={errors.clamp_qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12}>
            Clamp Hardware:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.clamp_hardware_mat?true:false}>
              <InputLabel>Clamp Hardware</InputLabel>
                <Controller
                  control={control}
                  name="clamp_hardware_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      // defaultValue={getValues('clamp_hardware_mat')}
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Clamp Hardware"
                    >
                      {hardwareMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.clamp_hardware_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Clamp Hardware Specifications"
              {...register("clamp_hardware_spec")}
              variant="outlined" fullWidth
              error={(errors.clamp_hardware_spec?true:false)}
              helperText={errors.clamp_hardware_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Clamp Hardware Qty" type="number"
              {...register("clamp_hardware_qty")}
              variant="outlined" fullWidth
              error={(errors.clamp_hardware_qty?true:false)}
              helperText={errors.clamp_hardware_qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12}>
            Hub Spool Hardware:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.hub_spool_hardware_mat?true:false}>
              <InputLabel>Hub Spool Hardware</InputLabel>
                <Controller
                  control={control}
                  name="hub_spool_hardware_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Hub Spool Hardware"
                    >
                      {hardwareMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.hub_spool_hardware_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Spool Hardware Specifications"
              {...register("hub_spool_hardware_spec")}
              variant="outlined" fullWidth
              error={(errors.hub_spool_hardware_spec?true:false)}
              helperText={errors.hub_spool_hardware_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Hub Spool Qty" type="number"
              {...register("hub_spool_hardware_qty")}
              variant="outlined" fullWidth
              error={(errors.hub_spool_hardware_qty?true:false)}
              helperText={errors.hub_spool_hardware_qty?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12}>
            Blades:
          </Grid>
          <Grid item xs={12} lg={4}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.blades_mat?true:false}>
              <InputLabel>Blades Material</InputLabel>
                <Controller
                  control={control}
                  name="blades_mat"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="Blades Material"
                    >
                      {bladeMaterialArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.blades_mat?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Blades Specifications"
              {...register("blades_spec")}
              variant="outlined" fullWidth
              error={(errors.blades_spec?true:false)}
              helperText={errors.blades_spec?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              label="Blades Qty" type="number"
              {...register("blades_qty")}
              variant="outlined" fullWidth
              error={(errors.blades_qty?true:false)}
              helperText={errors.blades_qty?'This field is required':''}
            />
          </Grid>
        </Grid>
        
        <br/>
        <Divider />
        <br/>
        
        <Typography variant="h5" gutterBottom>
          <b>Information block C (DRAWING DATA)</b>
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Client"
              {...register("client")}
              variant="outlined" fullWidth
              error={(errors.client?true:false)}
              helperText={errors.client?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Location"
              {...register("client_location")}
              variant="outlined" fullWidth
              error={(errors.client_location?true:false)}
              helperText={errors.client_location?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="PO Number"
              {...register("po_number")}
              variant="outlined" fullWidth
              error={(errors.po_number?true:false)}
              helperText={errors.po_number?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="PO Date"
              {...register("po_date")}
              variant="outlined" fullWidth
              error={(errors.po_date?true:false)}
              helperText={errors.po_date?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormControl variant="outlined" className={classes.formControl} error={errors.company_name?true:false}>
              <InputLabel>GA Heading</InputLabel>
                <Controller
                  control={control}
                  name="ga_heading"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      value={value} disabled={projectState!=="new"}
                      onChange={onChange}
                      label="GA Heading"
                    >
                      {gaHeadingArr.map(el=>{
                        return <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                      })
                      }
                    </Select>
                  )}
                />
                <FormHelperText>{errors.company_name?'This field is required':''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Drawing Number"
              {...register("drawing_number")}
              variant="outlined" fullWidth
              error={(errors.make?true:false)}
              helperText={errors.make?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="GA Drawing Date"
              {...register("ga_drawing_date")}
              variant="outlined" fullWidth
              error={(errors.ga_drawing_date?true:false)}
              helperText={errors.ga_drawing_date?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Unit"
              {...register("unit")}
              variant="outlined" fullWidth
              error={(errors.unit?true:false)}
              helperText={errors.unit?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Company Name"
              {...register("company_name")}
              variant="outlined" fullWidth
              error={(errors.company_name?true:false)}
              helperText={errors.company_name?'This field is required':''}
            />
          </Grid>
        </Grid>

        <br/>
        <Divider />
        <br/>
        
        <Typography variant="h5" gutterBottom>
          <b>Information block D (VALUES)</b>
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Fan Diameter"
              {...register("dimension_a")}
              variant="outlined" fullWidth
              error={(errors.dimension_a?true:false)}
              helperText={errors.dimension_a?'Please enter customer name':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Blade Length"
              {...register("dimension_b")}
              variant="outlined" fullWidth
              error={(errors.dimension_b?true:false)}
              helperText={errors.dimension_b?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Hub Diameter"
              {...register("dimension_c")}
              variant="outlined" fullWidth
              error={(errors.dimension_c?true:false)}
              helperText={errors.dimension_c?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Bore"
              {...register("dimension_d")}
              variant="outlined" fullWidth
              error={(errors.dimension_d?true:false)}
              helperText={errors.dimension_d?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Keyway"
              {...register("dimension_e")}
              variant="outlined" fullWidth
              error={(errors.dimension_e?true:false)}
              helperText={errors.dimension_e?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Blade Shoulder"
              {...register("dimension_f")}
              variant="outlined" fullWidth
              error={(errors.dimension_f?true:false)}
              helperText={errors.dimension_f?'This field is required':''}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              label="Blade Tip"
              {...register("dimension_g")}
              variant="outlined" fullWidth
              error={(errors.dimension_g?true:false)}
              helperText={errors.dimension_g?'This field is required':''}
            />
          </Grid>
        </Grid>
        <br/>
        <Divider />
        <br/>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <Button
                variant="contained"
                color="primary"
                size="large"
                disabled={true}
                // style={{marginLeft:'20px',backgroundColor:'rgb(245, 154, 36)'}}
                onClick={viewIn3D}
            >
                View in 3D 
            </Button>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                style={{marginLeft:'20px'}}
                // onClick={()=>{
                //   const values = getValues();
                //   dispatch(updateProjectDetails(values));
                // }}
            >
                Next
            </Button>
          </Grid>
        </Grid>
        <AlertComponent open={openAlert} message="Changes saved successfully." severity="success" handleClose={()=>{setOpenAlert(false)}} />
        <AlertComponent open={openErrAlert} message="Something went wrong. Please Try again." severity="error" handleClose={()=>{setOpenErrAlert(false)}} />
        </form>
  
    )
  }